<template>
  <expansion-panel
    key="expansion-panel-vehicle-registration"
    :title="$t('offer-manager.create.step-vehicle-registration.title')"
    :readonly="panelReadonly"
    :hideDivider="panelHideDivider">
    <template v-slot:panel-content>
      <m-form-row :label="$t('offer-manager.create.step-vehicle-registration.lbl-vehicle-registration')">
        <v-row>
          <v-col class="col-4">
            <mapit-input
              uid="vehicleRegistrationPrice"
              :value="registrationPrice"
              :placeholder="$t('offer-manager.create.step-vehicle-registration.lbl-tariff-placeholder')"
              :type="InputTypes.PRICE"
              @changeValue="value => updateOffer('setRegistrationPrice', value)"
              :forceFloat="true"
              :hideDetails="true"
              :disabled="disabled" />
          </v-col>
          <v-col class="col-4">
            <discount-field
              uid="vehicleRegistrationDiscounts"
              :valueCurrency="registrationDiscount"
              :valuePercentage="registrationDiscountPercent"
              :placeholder="$t('offer-manager.create.step-vehicle-registration.lbl-discount-placeholder')"
              @changeValueCurrency="value => updateOffer('setRegistrationDiscount', value)"
              @changeValuePercentage="value => updateOffer('setRegistrationDiscountPercent', value)"
              :rulesPercentage="registrationDiscountRulesPercentage"
              :rulesCurrency="registrationDiscountRules"
              :disabled="!registrationPrice || disabled"
              :hideDetails="true"
              :maxCurrency="registrationPrice" />
          </v-col>
          <v-col class="col-4">
            <mapit-input
              uid="vehicleRegistrationTotalPrice"
              :value="(registrationTotalPrice || 0).toFixed(2)"
              :placeholder="$t('offer-manager.create.step-vehicle-registration.lbl-price-placeholder')"
              :type="InputTypes.PRICE"
              :isReadonly="true"
              :hideDetails="true"
              :disabled="disabled" />
          </v-col>
          <v-col class="col-12 color-red fs-14" v-if="error">
            {{ error }}
          </v-col>
        </v-row>
      </m-form-row>
    </template>
  </expansion-panel>
</template>

<script lang="ts">
import {defineComponent, ref, watch} from '@vue/composition-api'

import DiscountField from '@/components/general/DiscountField.vue'
import ExpansionPanel from '@/components/general/ExpansionPanel.vue'
import MapitInput from '@/components/general/MapitInput.vue'
// @ts-ignore
import {registrationDiscountRules, registrationDiscountRulesPercentage} from '@/helpers/offer-manager-rules'
import {InputTypes} from '@/utils/constants'
import {mapGetters} from '@/utils/map-store'

export default defineComponent({
  name: 'VehicleRegistration',
  components: {ExpansionPanel, DiscountField, MapitInput},
  props: {
    hideDetails: {
      type: Boolean,
      default: false,
    },
    panelReadonly: {
      type: Boolean,
      default: false,
    },
    panelHideDivider: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, {root, emit}) {
    const error = ref('')

    const {
      getRegistrationPrice: registrationPrice,
      getRegistrationDiscount: registrationDiscount,
      getRegistrationDiscountPercent: registrationDiscountPercent,
      getRegistrationTotalPrice: registrationTotalPrice,
    } = mapGetters(root.$store.getters)

    watch(registrationPrice, validateDiscounts)
    watch(registrationDiscount, validateDiscounts)
    watch(registrationDiscountPercent, validateDiscounts)

    function validateDiscount(value: any) {
      return (
        !value ||
        !registrationPrice.value ||
        (registrationPrice.value &&
          parseFloat(value) <= parseFloat(registrationPrice.value) &&
          parseFloat(value) >= 0) ||
        'Error'
      )
    }

    function updateOffer(action: string, value: any) {
      root.$store.dispatch(action, value)
      emit('validateForm')
    }

    function validateDiscounts() {
      if (validateDiscount(registrationDiscount.value) !== 'Error') {
        if (registrationDiscountPercent.value >= 0 && registrationDiscountPercent.value <= 100) {
          error.value = ''
        } else {
          error.value = root.$t(
            'offer-manager.create.step-vehicle-registration.lbl-error-discount-percentage',
          ) as string
        }
      } else {
        error.value = root.$t('offer-manager.create.step-vehicle-registration.lbl-error-discount') as string
      }
    }

    return {
      InputTypes,
      error,
      registrationPrice,
      registrationDiscount,
      registrationDiscountPercent,
      registrationTotalPrice,
      registrationDiscountRules,
      registrationDiscountRulesPercentage,
      validateDiscount,
      updateOffer,
      validateDiscounts,
    }
  },
})
</script>
